import type { FaireProductEntity } from "../../entity_types/product";

export const p_gyys3q7z36: FaireProductEntity = {
  token: "p_gyys3q7z36",
  type: "product",
  name: "Women's Cherry Novelty Socks",
  brandToken: "b_a48i0fg8",
  brandName: "Selini New York",
  imageUrl:
    "https://cdn.faire.com/fastly/88479fe11a876208fc52a4b1c1edc649ca26135a79beacc256bf9f98837d7ce3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf5f57d94d9230da8d705a833e0ec7e0e6481d3b5d9e2d63db70ab7133729928.jpeg",
    "https://cdn.faire.com/fastly/bbd11b7a44c5d409fbb1ef55009c94e187641f9ccc696d42cbc45660854c3d88.jpeg",
    "https://cdn.faire.com/fastly/3929c94b36005eced1f8a08548fb702260413826efc4e4c00798e3e902d7e8ff.jpeg",
  ],
  priceDollars: 1,
  description:
    "Add some fun to your outfit with our Novelty Socks. These socks are perfect for when you have to maintain being a professional but still have that burning desire to be fun & silly! These socks are super soft & comfy.\n\n• 70% Cotton, 25% Polyester, 5% spandex\n• Sock size: 9-11\n• Shoe size: 4-10\n• Machine wash, tumble dry low\n• Imported",
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:27.420Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
